import React, { useEffect, useState } from 'react';
import { Button as MIButton } from '@material-ui/core';
import { connect } from 'react-redux';
import styles from './reservation-list.module.scss';
import Tooltip from '@material-ui/core/Tooltip';
import { ErrorInfo, isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import { trackPage } from '../../../shared/services/utils/tracking/tracking.service';
import useWindowResizer from '../../../shared/hooks/window-resizer/window-resizer.hook';
import { InputText } from '../../../shared/components/core-ui/input-text/input-text.component';
import Select, { ValueType } from 'react-select';
import { getAllUnitTypes } from '../../../shared/services/data/unit-type.data';
import { UnitTypeUiModel } from '../../../shared/ui-models/unit-type.ui-model';
import Button, { ButtonSize } from '../../../shared/components/core-ui/button/button.component';
import { getModuleName } from '../../shared/services/reservation.service';
import { getAllReservations } from '../../shared/services/data.service';
import {
  ReservationListUiModel,
  ReservationUiModel
} from '../../../shared/ui-models/reservation.ui-model';
import { Tabs, TabsPosition } from '../../../shared/components/group-ui/tabs/tabs.component';
import { ReservationStatus } from '../../../shared/enums/reservation-status';
import EditIcon from '@material-ui/icons/Edit';
import { APP_ROUTES, PUBLIC_PATH } from '../../../shared/config/routes-config';
import { RouteConfig } from '../../../shared/interfaces/routes-config.interface';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { Pagination } from '../../../shared/components/core-ui/pagination/pagination.component';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
      fontSize: '1.5rem'
    }
  }
});
const useSelectedRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
      fontSize: '1.5rem'
    }
  }
});

function Row(props: { reservation: ReservationUiModel }) {
  const { reservation } = props;
  const classes = useRowStyles();
  const selectedClasses = useSelectedRowStyles();

  return (
    <>
      <TableRow
        className={
          reservation.status === ReservationStatus.CHECKED_IN_STARTED
            ? selectedClasses.root
            : classes.root
        }
      >
        {/* <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell> */}
        <TableCell>
          <div
            className={
              styles['reservation-list-container__reservation-item__reservation-card__actions']
            }
          >
            <MIButton
              aria-controls="property-menu"
              aria-haspopup="true"
              onClick={() => {
                window.open(
                  PUBLIC_PATH +
                    (APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH.replace(
                      ':id',
                      reservation.id as string
                    ),
                  '_blank'
                );
              }}
            >
              <EditIcon fontSize={'large'} color="inherit" />
            </MIButton>
          </div>
        </TableCell>
        <TableCell component="th" scope="row">
          {reservation.id}
        </TableCell>
        <TableCell>
          <div
            className={`${styles['reservation-list-container__reservation-item__status']} ${
              styles[`reservation-list-container__reservation-item__status--${reservation.status}`]
            }`}
          >
            {reservation.status ? reservation.status.replace('_', ' ') : ''}
          </div>
        </TableCell>
        <TableCell>{reservation.primaryGuestName}</TableCell>
        <TableCell>{new Date(reservation.checkInDate).toDateString()}</TableCell>
        <TableCell>{new Date(reservation.checkOutDate).toDateString()}</TableCell>
        <TableCell>{reservation.area}</TableCell>
        <TableCell>{reservation.propertyName}</TableCell>
        <TableCell>
          <Tooltip
            title={
              <span
                className={
                  styles[
                    'reservation-list-container__reservation-item__reservation-card__item__tooltip'
                  ]
                }
              >
                {reservation.unitName}
              </span>
            }
          >
            <div
              className={
                styles[
                  'reservation-list-container__reservation-item__reservation-card__item__value'
                ]
              }
            >
              {reservation.unitName}
            </div>
          </Tooltip>
        </TableCell>
      </TableRow>
      <TableRow>
        {/* <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  Guests List
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Phone</TableCell>
                      <TableCell>Gender</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reservation.history.map((historyRow) => (
                      <TableRow key={historyRow.date}>
                        <TableCell component="th" scope="row">
                          {historyRow.date}
                        </TableCell>
                        <TableCell>{historyRow.customerId}</TableCell>
                        <TableCell align="right">{historyRow.amount}</TableCell>
                        <TableCell align="right">
                          {Math.round(historyRow.amount * row.price * 100) / 100}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell> */}
      </TableRow>
    </>
  );
}
export const ReservationsListContainer = () => {
  const isMobileView = useWindowResizer();
  const [guestName, setGuestName] = useState('');
  const [reservations, setReservations] = useState<ReservationUiModel[]>([]);
  const [unitType, setUnitType] = useState<string | undefined>();
  const [unitTypeOptions, setUnitTypeOptions] = useState<
    { value: string | undefined; label: string }[]
  >([]);
  const [listCount, setListCount] = useState<number>(0);
  const [offset, setOffset] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [selectedStatus, setSelectedStatus] = useState<any>({
    status: ReservationStatus.IN_HOUSE
  });

  const getReservations = (query: object, offset: number, limit: number) => {
    getAllReservations(query, offset, limit).then(
      (response: ReservationListUiModel | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          setListCount(response.count);
          setReservations(response.reservationList);
        }
      }
    );
  };

  const getNewReservation = (offsetNumber: number) => {
    setOffset(offsetNumber);
    getReservations({ ...selectedStatus }, offsetNumber, limit);
  };

  useEffect(() => {
    trackPage('reservations-list');
    // eslint-disable-next-line react-hooks/exhaustive-deps

    getAllUnitTypes(getModuleName()).then((response: UnitTypeUiModel[] | ErrorInfo) => {
      // setLoadingData(false);
      if (!isErrorInfo(response)) {
        setUnitTypeOptions(
          response.map((unitType) => ({ value: unitType.id, label: unitType.name || '' }))
        );
      }
    });
    getReservations(
      {
        status: ReservationStatus.CHECKED_IN
      },
      offset,
      limit
    );
  }, []);

  useEffect(() => {
    getReservations({ ...selectedStatus }, offset, limit);
  }, [limit]);

  return (
    <div className={styles['reservation-list-container']}>
      <div className={styles['reservation-list-container__title']}>
        <span>Reservations</span>
      </div>

      <Tabs
        data={{
          tabsList: [
            { component: <></>, key: 'All' },
            { component: <></>, key: 'Currently Hosting' },
            { component: <></>, key: 'Upcoming' },
            { component: <></>, key: 'Checked Out' }
          ],
          defaultTab: 'Currently Hosting'
        }}
        style={{ position: TabsPosition.LEFT }}
        eventHandlers={{
          tabChangeHandler: (tabKey) => {
            setSelectedStatus;
            ({}); // reset previous status
            if (tabKey === 'All') {
              setSelectedStatus({
                status: [
                  ReservationStatus.CHECKED_IN,
                  ReservationStatus.CHECKED_OUT,
                  ReservationStatus.IN_HOUSE
                ]
              });
              getReservations(
                {
                  statusQuery: [
                    ReservationStatus.CHECKED_IN,
                    ReservationStatus.CHECKED_OUT,
                    ReservationStatus.IN_HOUSE
                  ]
                },
                offset,
                limit
              );
            } else if (tabKey === 'Currently Hosting') {
              setSelectedStatus({ status: ReservationStatus.IN_HOUSE });
              getReservations({ status: ReservationStatus.IN_HOUSE }, offset, limit);
            } else if (tabKey === 'Upcoming') {
              setSelectedStatus({ status: ReservationStatus.CHECKED_IN });
              getReservations({ status: ReservationStatus.CHECKED_IN }, offset, limit);
            } else {
              setSelectedStatus({ status: ReservationStatus.CHECKED_OUT });
              getReservations({ status: ReservationStatus.CHECKED_OUT }, offset, limit);
            }
          }
        }}
      />
      <div className={styles['reservation-list-container__reservation-item']}>
        <div className={styles['reservation-list-container__reservation-item__form-field']}>
          <div
            className={styles['reservation-list-container__reservation-item__form-field__label']}
          >
            Guest Name
          </div>
          <InputText
            data={{
              value: guestName
            }}
            config={{
              maxRows: 1,
              autoFocus: false
            }}
            eventHandlers={{
              onChangeHandler: (value: string, isValid: boolean) => {
                setGuestName(value);
              }
            }}
          />
        </div>

        <div className={styles['reservation-list-container__reservation-item__form-field']}>
          <div
            className={styles['reservation-list-container__reservation-item__form-field__label']}
          >
            Unit Type
          </div>
          <Select
            className={styles['reservation-list-container__reservation-item__form-field__select']}
            options={unitTypeOptions}
            onChange={(value: ValueType<{ value: string | undefined; label: string }, false>) => {
              setUnitType(value ? value.value : '');
            }}
          />
        </div>
        <div className={styles['reservation-list-container__reservation-item__button-container']}>
          <Button
            onClick={() => {
              const query: any = {};
              if (unitType) {
                query.unitTypeId = unitType;
              }
              if (guestName) {
                query.primaryGuestName = guestName;
              }
              getReservations(query, offset, limit);
            }}
            className={
              styles['reservation-list-container__reservation-item__button-container__btn']
            }
            tracking={{
              action: 'close',
              category: 'unit-types',
              label: 'add-unit-type-modal'
            }}
            size={isMobileView ? ButtonSize.full : ButtonSize.medium}
          >
            search
          </Button>
        </div>
      </div>
      <TableContainer component={Paper}>
        <Table aria-label="table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Id #</TableCell>
              <TableCell>Room</TableCell>
              <TableCell>Tags</TableCell>
              <TableCell>Contact Name</TableCell>
              <TableCell>Check In</TableCell>
              <TableCell>Check Out</TableCell>
              <TableCell>Area</TableCell>
              <TableCell>Property</TableCell>
              <TableCell>Unit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reservations.map((reservation) => (
              <Row key={reservation.id} reservation={reservation} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {listCount > 0 && (
        <Pagination
          itemCounts={listCount}
          itemsPerPage={limit}
          offset={offset}
          handlePageChange={(val) => getNewReservation(val)}
          handleItemsPerPage={(itemsPerPage) => setLimit(itemsPerPage)}
        />
      )}
    </div>
  );
};

export default connect()(ReservationsListContainer);
